import { render, staticRenderFns } from "./begDetail.vue?vue&type=template&id=e7069914&scoped=true&"
import script from "./begDetail.vue?vue&type=script&lang=ts&"
export * from "./begDetail.vue?vue&type=script&lang=ts&"
import style0 from "./begDetail.vue?vue&type=style&index=0&id=e7069914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7069914",
  null
  
)

export default component.exports